import { AutogenLayoutOfficeStateLocalWithholdingsReport } from "./autogen/AutogenLayoutOfficeStateLocalWithholdingsReport";

export class OfficeStateLocalWithholdingsReport extends AutogenLayoutOfficeStateLocalWithholdingsReport {
    override onLoad(): void {
        this.textboxReportBy.selectedItem = this.textboxReportBy.items[0];
    }

    public textboxReportByOnChange() {
        this.excludabletextboxLocation.textbox.clear();
        if (this.textboxReportBy.text === "State") {
            this.excludabletextboxLocation.textbox.caption = "States";
            this.excludabletextboxLocation.textbox.lookupModel = "lme/settlement/state";
            this.excludabletextboxLocation.textbox.lookupModelLayout = "lme/settlement/StateLookup";
        }
        else if (this.textboxReportBy.text === "County") {
            this.excludabletextboxLocation.textbox.caption = "Counties";
            this.excludabletextboxLocation.textbox.lookupModel = "lme/settlement/county";
            this.excludabletextboxLocation.textbox.lookupModelLayout = "lme/settlement/CountyLookup";
        }
        else if (this.textboxReportBy.text === "City") {
            this.excludabletextboxLocation.textbox.caption = "Cities";
            this.excludabletextboxLocation.textbox.lookupModel = "lme/settlement/city";
            this.excludabletextboxLocation.textbox.lookupModelLayout = "lme/settlement/CityLookup";
        }
    }

    checkboxIncludeSettlementOnChange(): void {
        this.excludabletextboxPayee.textbox.clear();
        if(this.checkboxIncludeSettlement.checked) {
            this.excludabletextboxPayee.textbox.lookupModel = "lme/settlement/transfer-to-settlement-payee";
            this.excludabletextboxPayee.textbox.lookupModelLayout = "lme/settlement/TransferToSettlementPayeeLookup";
        }
        else {
            this.excludabletextboxPayee.textbox.lookupModel = "lme/settlement/officepayroll/off-payee";
            this.excludabletextboxPayee.textbox.lookupModelLayout = "lme/settlement/officepayroll/OfficePayeeLookup";
        }
    }
}